import { Component, ReactNode } from 'react'
import { ModalNodeProps } from '../../../components/modal.component'
import { Button, DatePicker, Input, Select, Switch, TimePicker } from 'antd'
import { preventMouseEvent } from '../../../../utils'
import { asyncGetListVendors } from '../../../../services/vendors.service'
import {
  AccountInfoDto,
  BlockTimeType,
  CreateBlockOffOnceBody,
  CreateBlockOffRecurringBody,
  VendorInfoDto
} from '../../../../definition'
import { asyncGetListTechnicians } from '../../../../services/technician.service'
import moment from 'moment'
import { asyncCreateBlockoffOnce, asyncCreateBlockoffRecurring } from '../../../../services/booking.service'
import { toast } from 'react-toastify'

const dayOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']

export class BlockOffEmployeeTimeModal extends Component<
  ModalNodeProps,
  {
    vendors: VendorInfoDto[]
    technicians: AccountInfoDto[]
    selectVendorId?: string
    selectTechIds?: string[]
    type: BlockTimeType
    onceDate?: string
    fromDate?: string
    toDate?: string
    recurringDay?: string
    dayOfWeek?: string
    reason?: string
    partialDay?: boolean
    begin?: string
    end?: string

    selectVendorIdError?: boolean
    selectTechIdsError?: boolean
    typeError?: boolean
    onceDateError?: boolean
    recurringDayError?: boolean
    dayOfWeekError?: boolean
    partialDayError?: boolean
    beginError?: boolean
    endError?: boolean
  }
> {
  constructor(props: any) {
    super(props)
    this.state = {
      type: BlockTimeType.Once,
      vendors: [],
      technicians: []
    }
  }
  componentDidMount() {
    this.fetchData()
  }

  async fetchData() {
    const vendors = (await asyncGetListVendors({ all: true }))?.items || []
    const technicians = (await asyncGetListTechnicians({ all: true }))?.items || []
    this.setState({ vendors: vendors, technicians: technicians })
  }

  onSelectVendor(vendor: VendorInfoDto) {
    this.setState({
      selectVendorId: vendor.id,
      selectTechIds: [],
      selectVendorIdError: false
    })
  }

  async onSubmit() {
    const state = {
      ...this.state,
      begin: moment(this.state.begin, 'HH:mm').format('hh:mmA'),
      end: moment(this.state.end, 'HH:mm').format('hh:mmA')
    }
    if (!state.selectVendorId) {
      this.setState({ selectVendorIdError: true })
      toast.error('Vendor is required!')
      return
    }
    if (!state.selectTechIds || !state.selectTechIds.length) {
      this.setState({ selectTechIdsError: true })
      toast.error('Employees is required!')
      return
    }
    if (state.partialDay) {
      if (!state.begin) {
        this.setState({ beginError: true })
        toast.error('Start time is required!')
        return
      }
      if (!state.end) {
        this.setState({ endError: true })
        toast.error('End time is required!')
        return
      }
    }
    if (state.type === BlockTimeType.Once) {
      if (!state.fromDate || !state.toDate ) {
        this.setState({ onceDateError: true })
        toast.error('Date is required!')
        return
      }
      // Validate range: fromDate must not be after toDate
      if (moment(state.fromDate).isAfter(moment(state.toDate))) {
        this.setState({ onceDateError: true })
        toast.error('From Date cannot be after To Date!')
        return
      }
      if (state.partialDay) {
        // Validate time range: begin must not be after end
        const beginTime = moment(state.begin, 'HH:mm')
        const endTime = moment(state.end, 'HH:mm')
        if (beginTime.isAfter(endTime)) {
          this.setState({ beginError: true, endError: true })
          toast.error('Start time cannot be after End time!')
          return
        }
      }
      const bodyJson: CreateBlockOffOnceBody = {
        type: BlockTimeType.Once,
        employeeIds: state.selectTechIds,
        fromDate: state.fromDate,
        toDate: state.toDate,
        begin: state.partialDay ? state.begin : undefined,
        end: state.partialDay ? state.end : undefined,
        reason: state.reason
      }

      try {
        await asyncCreateBlockoffOnce(bodyJson)
        toast.success('Saved!')
        this.props.onDone?.()
      } catch (error: any) {
        const errMsg = error.response?.data?.error?.message || error.message
        console.error(errMsg)
        toast.error(<>{errMsg}</>)
      }
    }
    if (state.type === BlockTimeType.Recurring) {
      if (!state.dayOfWeek) {
        this.setState({ dayOfWeekError: true })
        toast.error('Day is required!')
        return
      }
      const bodyJson: CreateBlockOffRecurringBody = {
        type: BlockTimeType.Recurring,
        employeeIds: state.selectTechIds,
        dayOfWeek: state.dayOfWeek,
        begin: state.partialDay ? state.begin : undefined,
        end: state.partialDay ? state.end : undefined,
        reason: state.reason
      }

      try {
        await asyncCreateBlockoffRecurring(bodyJson)
        toast.success('Saved!')
        this.props.onDone?.()
      } catch (error: any) {
        const errMsg = error.response?.data?.error?.message || error.message
        console.error(errMsg)
        toast.error(<>{errMsg}</>)
      }
    }
  }

  render(): ReactNode {
    const filterOption = (input: string, option?: { label?: string; value?: string }) =>
      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())

    return (
      <div className='customer-modal'>
        <form onSubmit={this.onSubmit}>
          <div className='customer-modal-basic-info ' style={{ overflowX: 'hidden' }}>
            <div className='row'>
              <div className='col-12'>
                <div className='label-input'>
                  <label>
                    Vendor <span className='input-require'>*</span>
                  </label>
                  <Select
                    className={`${this.state.selectVendorIdError ? 'input-error' : ''} role`}
                    placeholder='Select'
                    value={this.state?.selectVendorId}
                    options={this.state?.vendors?.map((vendor) => {
                      return {
                        value: vendor.id,
                        label: vendor.name
                      }
                    })}
                    onChange={(value) => {
                      const vendor = this.state.vendors.find((vendor) => vendor.id === value)
                      if (vendor) this.onSelectVendor(vendor)
                    }}
                    filterOption={filterOption}
                    showSearch
                  />
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-12'>
                <div className='label-input'>
                  <label>
                    Employees <span className='input-require'>*</span>
                  </label>
                  <Select
                    className={`${this.state.selectTechIdsError ? 'input-error' : ''} role block-off-time`}
                    mode='multiple'
                    placeholder='Select employee (s) to block off time'
                    value={this.state?.selectTechIds}
                    options={this.state?.technicians
                      ?.filter((tech) => tech.companyId === this.state.selectVendorId)
                      .map((tech) => {
                        return {
                          value: tech.id,
                          label: tech.profile?.name
                        }
                      })}
                    onChange={(value) => {
                      this.setState({
                        selectTechIds: value,
                        selectTechIdsError: false
                      })
                    }}
                    filterOption={filterOption}
                    showSearch
                  />
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-12'>
                <div className='label-input'>
                  <label>
                    Once/Recurring Option <span className='input-require'>*</span>
                  </label>
                  <Select
                    placeholder='Select employee (s) to block off time'
                    className='role'
                    value={this.state.type}
                    options={[
                      {
                        label: 'Does not repeat',
                        value: BlockTimeType.Once
                      },
                      { label: 'Recurring', value: BlockTimeType.Recurring }
                    ]}
                    onChange={(value) => {
                      this.setState({
                        type: value
                      })
                    }}
                    filterOption={filterOption}
                    showSearch
                  />
                </div>
              </div>
            </div>
            {this.state.type === BlockTimeType.Once && (
              <div className='row'>
                <div className='col-6'>
                  <div className='label-input'>
                    <label>
                      From Date<span className='input-require'>*</span>
                    </label>
                    <DatePicker
                      className={this.state.onceDateError ? 'input-error' : ''}
                      placeholder='--/--/----'
                      format='DD/MM/YYYY'
                      style={{ width: 192, height: 45 }}
                      onChange={(value) => {
                        this.setState({ fromDate: moment(value).format('YYYY-MM-DD'), onceDateError: false })
                      }}
                      allowClear={false}
                    />
                  </div>
                </div>
                 <div className='col-6'>
                  <div className='label-input'>
                    <label>
                      To Date<span className='input-require'>*</span>
                    </label>
                    <DatePicker
                      className={this.state.onceDateError ? 'input-error' : ''}
                      placeholder='--/--/----'
                      format='DD/MM/YYYY'
                      style={{ width: 192, height: 45 }}
                      onChange={(value) => {
                        this.setState({ toDate: moment(value).format('YYYY-MM-DD'), onceDateError: false })
                      }}
                      allowClear={false}
                    />
                  </div>
                </div>
              </div>
            )}
            {this.state.type === BlockTimeType.Recurring && (
              <div className='row'>
                <div className='col-12'>
                  <div className='label-input'>
                    <label>
                      Day of the Week<span className='input-require'>*</span>
                    </label>
                    <Select
                      className={`${this.state.dayOfWeekError ? 'input-error' : ''} role`}
                      placeholder='Select'
                      value={this.state.dayOfWeek}
                      options={dayOfWeek.map((day) => {
                        return { value: day, label: day }
                      })}
                      onChange={(value) => {
                        this.setState({
                          dayOfWeek: value,
                          dayOfWeekError: false
                        })
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
            <div className='row'>
              <div className='col-12'>
                <div className='label-input'>
                  <label>Block Off Partial Day</label>
                  <Switch
                    onChange={(checked) => {
                      this.setState({
                        partialDay: checked
                      })
                    }}
                    checked={this.state.partialDay}
                  />
                </div>
              </div>
            </div>
            {this.state.partialDay && (
              <div className='row'>
                <div className='col-12' style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div className='label-input'>
                    <label>Block Off Start Time</label>
                    <TimePicker
                      className={`${this.state.beginError ? 'input-error' : ''} '`}
                      style={{ width: 190 }}
                      value={this.state.begin ? moment(this.state.begin, 'HH:mm') : undefined}
                      format={'HH:mm'}
                      minuteStep={30}
                      disabledTime={() => {
                        return {
                          disabledHours: () => [0, 1, 2, 3, 4, 5, 6, 7]
                        }
                      }}
                      onChange={(value) => {
                        this.setState({
                          begin: moment(value).format('HH:mm'),
                          beginError: false
                        })
                      }}
                    />
                  </div>
                  <div className='label-input'>
                    <label>Block Off End Time</label>
                    <TimePicker
                      className={`${this.state.endError ? 'input-error' : ''} '`}
                      style={{ width: 190 }}
                      value={this.state.end ? moment(this.state.end, 'HH:mm') : undefined}
                      format={'HH:mm'}
                      minuteStep={30}
                      disabledTime={() => {
                        return {
                          disabledHours: () => [0, 1, 2, 3, 4, 5, 6, 7]
                        }
                      }}
                      onChange={(value) => {
                        this.setState({
                          end: moment(value).format('HH:mm'),
                          endError: false
                        })
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
            <div className='row'>
              <div className='col-12'>
                <div className='label-input'>
                  <label>Reason(Optional)</label>
                  <Input
                    placeholder='Please specify a reason'
                    value={this.state.reason}
                    onChange={(e) => {
                      this.setState({
                        reason: e.target.value
                      })
                    }}
                  />
                </div>
              </div>
            </div>
            <div className='row' style={{ justifyContent: 'center' }}>
              <label className='label-input'>
                <Button className='create-customer-btn' onClick={preventMouseEvent(this.onSubmit.bind(this))}>
                  Save
                </Button>
              </label>
            </div>
          </div>
        </form>
      </div>
    )
  }
}
